import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import {
  DesktopClient,
  DeviceType,
  DeviceTypeCategory,
} from "../../../api/firebase/types/device.types";

const DeviceListTemplate = (
  device: DeviceType | (DesktopClient & { id: string })
) => {
  return (
    <div className="p-d-flex p-jc-between">
      <div className="p-d-flex p-ai-center">
        <span
          className={`pi pi-${
            device.typeCategory === DeviceTypeCategory.DESKTOP_CLIENT
              ? "desktop"
              : "mobile"
          } p-mr-2`}
        />
        {device.name}
      </div>
      <div className="p-d-flex p-ai-center">
        {device.deviceTestMode && (
          <Badge value="Testmodus" severity="warning" />
        )}
        {!device.scenarioIds?.length && (
          <Button
            className="list-icon-button p-button-rounded p-button-danger p-ml-2"
            icon="pi pi-exclamation-triangle"
            tooltip="Das Gerät wurde noch nicht konfiguriert!"
          />
        )}
      </div>
    </div>
  );
};

export default DeviceListTemplate;
